import { RadioButton } from "primereact/radiobutton";
import React, { useEffect, useState } from "react";
import Axios from "../../../api/Axios";
import storage from "../../../Services/Storage";
import { toast } from "react-toastify";
import Loader from "../../../Components/Loader";

const BulkInvoicingApplicability = () => {
    const auth = storage.getLocal("user");
    const [loading, setLoading] = useState(false);

    let categories = [
        { name: "Active", key: "Y" },
        { name: "InActive", key: "N" },
    ];
    const [selectedCategory, setSelectedCategory] = useState([]);

    useEffect(() => {
        const onPageLoad = async () => {
            try {
                setLoading(true);
                const paymnturl = "ParameterSettings/GetBulkInvoicingItem?";
                const upiData = `${paymnturl}compid=${auth.CompId}`;
                let dataresponse = await Axios.get(upiData);
                if (dataresponse?.data?.Data[0]?.Column1 == "Y") {
                    setSelectedCategory(categories[0]);
                } else {
                    setSelectedCategory(categories[1]);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };
        onPageLoad();
    }, []);

    const savebulkInvoice = async () => {
        try {
            setLoading(true);
            const paymnturl = "ParameterSettings/SaveBulkInvSetting";
            let payload = {
                strCompId: auth.CompId,
                strChecked: selectedCategory.key,
            };
            const response = await Axios.post(
                paymnturl,
                JSON.stringify(payload)
            );
            console.log(response?.data?.Message);
            toast.success("Data saved successfully", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 5000,
            });
            window.location.reload();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <div className="col-12 pt-0 pb-4">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <h3 className="py-2">Bulk Invoicing Applicability</h3>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <div className="text-end">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={savebulkInvoice}
                            >
                Save
                            </button>
                        </div>
                    </div>
                </div>
                <section className="sales-box">
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col-lg-5 col-md-12 col-sm-12">
                            <form>
                                <div className="d-block mb-2">
                                    <label className="form-label">
                    Bulk Invoicing Applicable?
                                    </label>
                                    <div className="d-block mt-1">
                                        {categories.map((category) => {
                                            return (
                                                <div
                                                    key={category.key}
                                                    className="float-start mt-2 me-3"
                                                >
                                                    <RadioButton
                                                        inputId={category.key}
                                                        name="category"
                                                        value={category}
                                                        onChange={(e) => setSelectedCategory(e.value)}
                                                        checked={selectedCategory.key === category.key}
                                                    />
                                                    <label htmlFor={category.key} className="ml-2 ms-2">
                                                        {category.name}
                                                    </label>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </form>
                        </div>
                        {loading?<><Loader/></>:null}
                        <div className="col-lg-7 col-md-12 col-sm-12">
                            <div className="text-end me-5">
                                <img
                                    src={require("../../../Assets/Images/switches.png")}
                                    className="w-40"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default BulkInvoicingApplicability;
